"use client";
import { jsx as s } from "react/jsx-runtime";
import * as t from "@radix-ui/react-visually-hidden";
import { forwardRef as d } from "react";
const e = d((i, o) => /* @__PURE__ */ s(t.Root, { "data-slot": "visually-hidden", ...i, ref: o }));
e.displayName = "VisuallyHidden";
export {
  e as VisuallyHidden
};
